import React from "react";

const comparator = (x, y) => {
  const comparator = (a, b) => {
    if (a?.name < b?.name) {
      return -1;
    } else if (a?.name > b?.name) {
      return 1;
    } else {
      return 0;
    }
  };
  return comparator(x, y);
};

export default comparator;
